<!-- begin:: Brand -->
<div class="brand flex-column-auto" [ngClass]="brandClasses" id="kt-aside">
    <!--begin::Logo-->
    <div class="row brand-logo">
        <div class="col-4">
            <a href="javascript:;" routerLink="/home">
                <img style="width: 135%;" id="logo" alt="logo" [attr.src]="headerLogo" />
            </a>
        </div>
        <div class="col-6 mt-sm-4 ml-3">
            <h3 href="javascript:;" class="text-white">{{'MENU.FINANCIAL' | translate}}</h3>
        </div>
    </div>
    <!--end::Logo-->

    <ng-container *ngIf="asideSelfMinimizeToggle">
        <!--begin::Toggle-->
        <button class="brand-toggle btn btn-sm px-0" id="kt_aside_toggle" (click)="toggleAsideClick()">
            <span class="svg-icon svg-icon-xl"
                [inlineSVG]="'./assets/media/svg/icons/Navigation/Angle-double-left.svg'"></span>
        </button>
        <!--end::Toolbar-->
    </ng-container>
</div>
<!-- end:: Brand -->